// In-app replacement for window.confirm / window.alert.
//
// Native browser dialogs are ugly and — critically — can't be driven by
// in-page automation (our Playwright E2E suite, the Chrome-extension tester).
// These helpers render a real in-app modal (see GlobalDialog) and resolve a
// promise when the user clicks, so callers do `if (await confirmDialog(...))`.

let _handler = null;       // set by the mounted <GlobalDialog/>
let _autoConfirm = false;  // when true, confirms auto-resolve (in-app test runner)

export function _registerDialogHandler(fn) { _handler = fn; }

// The in-app test runner can't click its own modals mid-run, so it flips this
// on for the duration of a run to auto-accept confirms (mirrors the old
// window.confirm override it used to do).
export function setDialogAutoConfirm(v) { _autoConfirm = !!v; }

function normalise(opts) {
  return typeof opts === 'string' ? { message: opts } : (opts || {});
}

export function confirmDialog(opts) {
  const o = normalise(opts);
  return new Promise((resolve) => {
    if (_autoConfirm) { resolve(true); return; }
    if (!_handler) { resolve(window.confirm(o.message)); return; } // SSR/early fallback
    _handler({ ...o, kind: 'confirm', resolve });
  });
}

export function alertDialog(opts) {
  const o = normalise(opts);
  return new Promise((resolve) => {
    if (_autoConfirm) { resolve(); return; }
    if (!_handler) { window.alert(o.message); resolve(); return; }
    _handler({ ...o, kind: 'alert', resolve });
  });
}
